import React from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaWhatsapp,
  FaEnvelope,
  FaGlobe,
} from "react-icons/fa";
import "./ThankYouPage.css";

const ThankYouPage = () => {
  return (
    <div className="thank-you-container">
      <div className="thank-you-card">
        <div className="check-icon">✔</div>
        <h1>Thank You</h1>
        <p>for Reaching Out!</p>

        <div className="buttons-container">
          <div className="connect-card">
            <p>Connect with us</p>
            <div className="social-icons">
              <a
                href="https://www.facebook.com/people/Bombay-Dental-Company/61564829128587/"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.instagram.com/bombaydentalcompany"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://wa.me/+918882672980?text="
                target="_blank"
                rel="noreferrer"
              >
                <FaWhatsapp />
              </a>
              <a
                href="mailto:bombaydentalcompany@gmail.com"
                target="_blank"
                rel="noreferrer"
              >
                <FaEnvelope />
              </a>
            </div>
          </div>

          <div className="website-card">
            <p>Visit our website</p>
            <a
              href="https://bombaydentalcompany.com/"
              target="_blank"
              rel="noreferrer"
              className="website-button"
            >
              <FaGlobe /> Bombay Dental Company
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
